import {
  Alert,
  Typography,
  Stack,
  tokens,
  colorOrToken,
} from '@cast/design-system';

export const HelmScriptWarning = () => {
  return (
    <Stack
      data-testid="helm-script-warning"
      bgcolor={colorOrToken(
        'grey.800',
        tokens.theme.bg.structural.surfaceInverse
      )}
      p={24}
      minHeight={180}
      alignItems="center"
      justifyContent="center"
      sx={{
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
      }}
    >
      <Alert
        color="warning"
        size="sm"
        noIcon
        title="Helm doesn't support cluster optimization yet"
      >
        <Typography
          variant="P12R"
          color={colorOrToken(
            'grey.600',
            tokens.theme.fg.structural.secondaryOnInverse
          )}
        >
          To keep it, switch to <b>Script</b> or <b>Terraform</b>. To use Helm,
          remove Cluster optimization.
        </Typography>
      </Alert>
    </Stack>
  );
};
